"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

interface Props {
  userId: string;
}

export default function NewUserBanner({ userId }: Props) {
  const router = useRouter();

  useEffect(() => {
    const code = localStorage.getItem("raffaello-referral-code");

    if (code) {
      router.replace("/signup-success");
    }
  }, []);

  return null;
}
